export default __webpack_public_path__ + "static/media/touchscreen1.0793dd6b.svg";